import './style.scss';
import { Caption, CaptionButton } from 'views/mutual/caption';
import { SubUserList } from './module/subUserList';
import { UserManageHeader } from './module/subUserHeader';
import { PagePath } from 'constants/pagePath';
import { useSubUserList } from './hooks';
import { MessageModal } from 'views/mutual/modal/messageModal';
import { LoadingContainer } from 'views/mutual/loading';
import { ComponentControl } from 'views/mutual/componentControl';

export const SubUser = () => {
  const { subUserList, modalProps, onDelete } = useSubUserList();

  return (
    <>
      <div className="subUser">
        <Caption label="利用者一覧" right={<CaptionButton to={PagePath.SubUserAdd} label="利用者を追加" />} />
        <LoadingContainer isLoading={subUserList.fetching}>
          <div className="subUser_wrapper">
            <UserManageHeader />
            <ComponentControl
              isLoading={subUserList.fetching}
              items={subUserList.data?.GetSubUserList?.Data || []}
              noDataMessege="1件も登録されていません"
              componentName={SubUserList}
              onDelete={onDelete}
            />
          </div>
        </LoadingContainer>
      </div>
      <MessageModal {...modalProps} />
    </>
  );
};
